import { bindActionCreators, compose } from 'redux';
import { concat, filter, get, uniq } from 'lodash/fp';
import { connect } from 'react-redux';
import { CUSTOMER_NEEDS, NEEDS_PRODUCT_TYPE_SLUG } from '@ahmdigital/constants';
import React from 'react';

import { accordionId, outOfPocketSectionId, outOfPocketSectionIndex } from './constants';
import { scrollToElement } from '../../utils/ui';
import { SHORT_PAGE_TITLE_TEMPLATE } from '../../ahm-constants/ui';
import accordionActionCreators from '../../actions/accordion';
import AccordionSection from '../../components/sections/accordion-section';
import constants from '../../ahm-constants';
import data from './data';
import Head from '../../../utils/head';
import HeaderSection from './components/header-section';
import items from './content/items';
import NeedsProductDataLoader from '../../components/needs-product-data-loader';
import PregnancyCallout from './components/callout';
import ProductsSection from '../../components/sections/products-section';
import selectFilteredNeedsProductsByCustomer from '../../selectors/select-filtered-needs-products-by-customer';

// @ts-expect-error - Automatic, Please fix when editing this file
const onClickOutOfPocket = (actions, openIndices = []) => {
  const newOpenIndices = uniq(concat(openIndices, outOfPocketSectionIndex));
  actions.accordion.updateAccordionWithId({ id: accordionId, openIndices: newOpenIndices });
  scrollToElement(document.getElementById(outOfPocketSectionId));
};

type PregnancyPageProps = {
  actions: {};
  openIndices?: number[];
  products: {}[];
};

const PregnancyPage = ({ actions, openIndices, products }: PregnancyPageProps) => {
  // @ts-expect-error - Automatic, Please fix when editing this file
  const { headerSection, productSection } = data(() => onClickOutOfPocket(actions, openIndices));

  // Only show the $750 excess products
  const productSectionProducts = filter((product) => get('charges.excess.amount', product) === 750)(products);

  const productSectionProps = {
    compareButtonText: 'Compare these options',
    compareButtonToLink: `${constants.URLS.SALES.PRODUCT_LISTING}/${CUSTOMER_NEEDS.PREGNANCY_COVER}/${NEEDS_PRODUCT_TYPE_SLUG.COMBINED}`,
    data: productSection,
    products: productSectionProducts,
    withBorder: true,
  };

  return (
    <>
      <Head titleTemplate={SHORT_PAGE_TITLE_TEMPLATE}>
        <title>Private health insurance for pregnancy</title>
        <meta
          name="description"
          content="Going private provides continuity of care & offers you more choice throughout your pregnancy & birth. Get extra support on your journey. Find out more."
        />
      </Head>

      <HeaderSection {...{ data: headerSection }} />
      <ProductsSection {...productSectionProps} />
      <PregnancyCallout />
      <AccordionSection
        accordionId={accordionId}
        // @ts-expect-error - Automatic, Please fix when editing this file
        items={items}
        image={null}
        title="More about our hospital cover for pregnancy and birth"
        withBorder
      />
    </>
  );
};

PregnancyPage.defaultProps = {
  openIndices: null,
};

// @ts-expect-error - Automatic, Please fix when editing this file
const mapStateToProps = (state, props) => ({
  openIndices: get(`accordion.openIndices.${accordionId}`, state),
  products: selectFilteredNeedsProductsByCustomer(state, props),
});

// @ts-expect-error - Automatic, Please fix when editing this file
const mapDispatchToProps = (dispatch) => ({
  actions: {
    accordion: bindActionCreators(accordionActionCreators, dispatch),
  },
});

export default compose(NeedsProductDataLoader, connect(mapStateToProps, mapDispatchToProps))(PregnancyPage);

export { PregnancyPage as PregnancyPageForTest, onClickOutOfPocket };
